package nl.astraeus.wiki

import nl.astraeus.logger.Logger

val log = Logger()